import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, disableVariablesMapping } from 'store/data/variablesMapping';

type HandlerInput = Parameters<typeof disableVariablesMapping>;

export function useDisableVariableMapping(activityPayload: {
	setName?: string;
}): Operation<(...input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.DISABLE_VARIABLES_MAPPING,
		activityPayload
	);

	async function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(disableVariablesMapping(...input));
	}

	return [{ loading, error }, handler];
}
